exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".next-value {\n  -webkit-transition: 200ms ease opacity;\n  transition: 200ms ease opacity;\n  opacity: 0; }\n\n\n.cell-content:hover .next-value {\n  opacity: 0.3; }\n\n\n.cell-content {\n  cursor: pointer;\n  font-size: 48px;\n  background: #AAC0AA;\n  width: 100px;\n  height: 100px;\n  display: inline-block;\n  line-height: 100px;\n  border-radius: 10px;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/cell/cell.component.scss
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/cell/cell.component.scss
// module chunks = main